// Generated Module Configuration
export const moduleConfig = {
  "moduleConfig": {
    "name": "Channel Creator",
    "description": "",
    "size": "large",
    "theme": "uplynk",
    "endpoints": [
      {
        "root_url": "https://services.uplynk.com",
        "path": "/api2/channel/create",
        "method": "POST",
        "category": "Channel",
        "parameters": {
          "desc": {
            "type": "string",
            "examples": "Sports Channel",
            "required": true,
            "displayName": "Title",
            "placeholder": "",
            "helpText": "",
            "inputElement": "text"
          },
          "slicer_id": {
            "type": "string",
            "examples": "srt_slicer_1",
            "required": false,
            "displayName": "Encoder ID",
            "placeholder": "",
            "helpText": "",
            "inputElement": "text"
          },
          "require_drm": {
            "type": "integer",
            "examples": "0",
            "required": false,
            "displayName": "Token",
            "placeholder": "",
            "helpText": "",
            "inputElement": "checkbox"
          },
          "require_studio_drm": {
            "type": "integer",
            "examples": "0",
            "required": false,
            "displayName": "DRM",
            "placeholder": "",
            "helpText": "",
            "inputElement": "checkbox"
          }
        }
      }
    ],
    "callbacks": {
      '/api2/channel/create': {
        "afterResponse": {
          "actions": [
            // First action: Add entry to job state list showing we're starting
            {
              "action": 'sendNotification',
              "config": {
              "message": 'Channel Create Completed successfully',
              "type": 'success'
              }
            },    
            {
              "action": 'appendState',
              "config": {
                "state": 'default',
                "messageTemplate": {"title": "Channel Success", "value": "{id}"},
                "extractMapping": {
                  "id": 'data.channel.id',
                  "error": "data.error"

                  // "progress_percent": 0
                }
              }
            },
            // Second action: Store initial job information in shared params
            {
              "action": 'updateSharedParams',
              "config": {
                "extractMapping": {
                  "channel.id": "data.channel.id",
                  "channel.created": 'data.channel.created',
                  "playerURL": "https://content.uplynk.com/channel/{data.channel.id}.m3u8",
                }
              }
            }
          ]
        },
        "onError": {
          "actions": [
            // Error handling actions
            {
              "action": "sendNotification",
              "config": {
                "message": "Channel Create Error: {value}",
                "type": "error",
                "extractPath": "error.message"
              }
            },
            {
              "action": 'appendState',
              "config": {
                "state": 'error',
                "messageTemplate": {"title": "Channel Fail", "value": "{errorMessage}"},
                "extractMapping": {
                  "errorMessage": 'error.message',
                  // "progress_percent": 0
                }
              }
            }
          ]
        },
        "onComplete": {
          "actions": [
            // Error handling actions
            {
              "action": "sendNotification",
              "config": {
                "message": "Channel Create completed successfully",
                "type": "success"
              }
            },
            // {
            //   "action": 'appendState',
            //   "config": {
            //     "state": 'done',
            //     "messageTemplate": {"title": "Channel Fail", "value": {errorMessage}},
            //     "extractMapping": {
            //       "errorMessage": 'error.message',
            //     }
            //   }
            // }
          ]
        }
      }
    },
    "elements": []
  },
  "displayOrder": [
    {
      "endpointIndex": 0,
      "paramName": "desc"
    },
    {
      "endpointIndex": 0,
      "paramName": "slicer_id"
    },
    {
      "endpointIndex": 0,
      "paramName": "require_drm"
    },
    {
      "endpointIndex": 0,
      "paramName": "require_studio_drm"
    },
    {
      "type": "button",
      "elementId": "button_1741972236175"
    }
  ],
  "customElements": [
    {
      "id": "button_1741972236175",
      "type": "button",
      "label": "Apply",
      "variant": "primary",
      "action": "submit"
    }
  ]
};